export default __webpack_public_path__ + "static/media/gallery_01.c649a7b3.jpg";